import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';
import { CustomLoader } from '../../../../../components/custom-loader';

export const TrailerEventTabView = ({ eventData, isEventDataLoading }) => {
	if (isEventDataLoading) {
		return <CustomLoader />;
	}

	return (
		<div className="trailer-event-tab">
			<>
				{eventData ? (
					// eslint-disable-next-line react/no-danger
					<div className="trailer-event-tab__table" dangerouslySetInnerHTML={{ __html: eventData }} />
				) : (
					<div className="trailer-event-tab__empty-message">События не найдены</div>
				)}
			</>
		</div>
	);
};

TrailerEventTabView.propTypes = {
	eventData: PropTypes.string,
	isEventDataLoading: PropTypes.bool.isRequired,
};
